






























import moment from 'moment';
import { Component, Mixins } from 'vue-property-decorator';
import { Mall } from 'supporter';
import PageTitle from '@/components/common/PageTitle.vue';
import ItemTable from '@/components/common/privacyAccessHistories/ItemTable.vue';
import ContentTop from '@/components/common/privacyAccessHistories/ContentTop.vue';
import HistoryInfoLayer from '@/components/common/privacyAccessHistories/HistoryInfoLayer.vue';
import PrivacyAccessHistoriesGrid from '@/components/common/privacyAccessHistories/PrivacyAccessHistoriesGrid';
import { namespace } from 'vuex-class';
import { getToday } from '@/utils/dateUtils';
const mallModule = namespace('mall');

const MAX_MONTH_LIMIT = 6;

@Component({
  components: { HistoryInfoLayer, ContentTop, PageTitle, ItemTable },
})
export default class PrivacyAccessHistories extends Mixins(PrivacyAccessHistoriesGrid) {
  @mallModule.Getter('malls') private malls!: Mall[];
  @mallModule.Getter('mallByMallNo') private mallByMallNo;
  private size: number = 30;
  private showEditLayer = false;
  private getRowData = {};
  private accessHistoriesListContent = {
    contents: [
      {
        workingTypeDescription: '',
        ip: '',
        adminId: '',
        menu: '',
        accessDateTime: '',
        workingDetail: '',
        workingType: '',
        pageLabel: '',
        menuLabel: '',
      },
    ],
    totalCount: 0,
  };
  private request: any = {
    params: {}
  };
  public isValidSearchRequests: boolean = false;

  private contentBottomOption: any = {
    haveConfigBtn: true,
    haveExcelDownBtn: true,
    excelDownInfo: {
      columns: {
        accessDateTime: 'ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_ACCESS_DATE_TIME',
        ip: 'ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_IP',
        adminId: 'ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_ADMIN_ID',
        menuUri: 'ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_ACCESS_URL',
        workingTypeDescription: 'ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_WORKING_TYPE_DESCRIPTION',
      },
      fileName: 'privacy_histories_' + getToday(),
      nameDateFormat: 'YYYYMMDD_HHmmss',
      formatters: {},
    },
  };

  private mallName = null;

  private setMallName(mallName) {
    this.mallName = mallName;
  }

  private search(page: number = 1, size?: number): void {
    if (size) {
      this.size = size;
    }
    const refContentTop = this.$refs.contentTop as any;
    let category = 'CUSTOMER';
    if (refContentTop.focusTableTabName === 'adminTab') {
      category = 'ADMIN';
    }
    this.request = {
      params: {
        page: page,
        pageSize: this.size,
        adminId: refContentTop.adminId,
        startDateTime: refContentTop.startYmdt + ' 00:00:00',
        endDateTime: refContentTop.endYmdt + ' 23:59:59',
        category: category,
        mallNo: refContentTop.mallNo,
      },
    };

    $('#loading').show();
    this.$api
      .getPrivacyAccessHistories(this.request)
      .then(({ data }) => {
        this.accessHistoriesListContent.contents = data.contents.map((content, index) => {
          return {
            ...content,
            mallName: this.mallName,
            workingDetail: content.workingDetail as string,
            key: `${content.accessDateTime} - ${page} - ${index}`
          }
        });
        this.accessHistoriesListContent.totalCount = data.totalCount;
        this.gridProps.options.pageOptions.page = page;
        this.gridProps.options.pageOptions.perPage = this.size;
        this.gridProps.options.pageOptions.totalCount = data.totalCount;
      })
      .finally(() => {
        $('#loading').hide();
      });
  }
  private workDetailBtnClick(e) {
    e.preventDefault();
    const focusRowKey = (this.$refs.accessHistoryGird as any).getFocusedCell().rowKey;
    this.getRowData = (this.$refs.accessHistoryGird as any).getRow(focusRowKey);
    this.showEditLayer = true;
  }
  mounted() {
    $('body').on('click', '.workDetailBtn', $.proxy(this.workDetailBtnClick, this));
  }
  destroyed() {
    $('body').off('click', '.workDetailBtn', $.proxy(this.workDetailBtnClick, this));
  }

  public checkExcelDownValidation() {
    const {startDateTime, endDateTime} = this.request.params;
    const diffMonths = moment(endDateTime).diff(moment(startDateTime), 'months',  true);

    if (diffMonths > MAX_MONTH_LIMIT) {
      alert( this.$t('ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_EXCEL_RANGE_VALIDATION_CHECK_MESSAGE'));
      return false;
    }

    return true;
  }
}
